import Icon from '@mui/material/Icon';
import Keys from '../pages/apikeys';
import AppHome from 'pages/apphome';
import AnonymizeTools from 'pages/anonymize/tools';
import Prompts from 'pages/prompts';
import Users from 'pages/users';
import AdminAssistants from 'pages/assistants/admin';
import Embedding from 'pages/embedding';
import ChatBox from 'pages/chatbox';
import { useAuth } from 'hook/useAuth';
import { RoleEnum } from 'pages/authentication/sign-in';
import { KnowledgeBase } from 'pages/knowledgeBase';
import { Assistants } from 'pages/assistants';
import Usages from 'pages/usages';
import { AssistantBuilder } from 'pages/assistants/builder';
import KnowledgeBaseDocuments from 'pages/knowledgeBase/documents/knowledgeBaseDocuments';
import AiProviders from 'pages/aiProviders';
import AiModels from 'pages/aiModels';
import Scripts from 'pages/scripts';
import KnowledgeBaseBatch from 'pages/knowledgeBase/batch/knowledgeBaseBatch';
import Accounts from 'pages/accounts';
import ImportExportConfiguration from 'pages/importExportConfiguration';

const useRoutes = () => {
  const { currentUser } = useAuth();

  const mainRoutes = [
    {
      type: 'collapse',
      name: 'Administration',
      key: 'administration',
      icon: <Icon fontSize="small">admin_panel_settings</Icon>,
      viewType: 'home',
      path: 'admin',
      functionality: RoleEnum.ADMIN,
      operation: 'read'
    },
    {
      type: 'collapse',
      name: 'KnowledgeBase',
      key: 'knowledgeBase',
      icon: <Icon fontSize="small">school</Icon>,
      viewType: 'knowledgeBase',
      path: 'knowledgeBase',
      component: <KnowledgeBase />,
      functionality: RoleEnum.ADMIN,
      operation: 'read'
    },
    {
      type: 'collapse',
      name: 'Assistants',
      key: 'assistants',
      icon: <Icon fontSize="small">assistant_rounded</Icon>,
      viewType: 'assistants',
      path: 'assistants',
      component: <Assistants />,
      functionality: RoleEnum.ASSISTANT,
      operation: 'read'
    },
    {
      type: 'collapse',
      name: 'DigiGuide',
      key: 'chatbox',
      icon: <Icon fontSize="small">forum</Icon>,
      viewType: 'chatbox',
      path: 'chatbox',
      component: <ChatBox />,
      functionality: RoleEnum.ASSISTANT,
      operation: 'read'
    },
    {
      type: 'collapse',
      name: 'AssistantBuilder',
      key: 'assistantBuilder',
      visibleInMenu: false,
      icon: <Icon fontSize="small">assistant_rounded</Icon>,
      viewType: 'assistantBuilder',
      path: 'assistants/builder/:assistantId',
      component: <AssistantBuilder />,
      functionality: RoleEnum.ASSISTANT,
      operation: 'read'
    },
    {
      type: 'collapse',
      name: 'KnowledgeBaseDocuments',
      key: 'knowledgeBaseDocuments',
      visibleInMenu: false,
      icon: <Icon fontSize="small">school</Icon>,
      viewType: 'knowledgeBaseDocuments',
      path: 'knowledgeBase/:knowledgeBaseId',
      component: <KnowledgeBaseDocuments />,
      functionality: RoleEnum.ADMIN,
      operation: 'read'
    }
  ];

  const adminRoutes = [
    {
      type: 'collapse',
      name: 'Home',
      key: 'home',
      icon: <Icon fontSize="small">home</Icon>,
      viewType: 'home',
      path: 'home',
      component: <AppHome />,
      functionality: RoleEnum.ADMIN,
      operation: 'read'
    },
    {
      type: 'collapse',
      name: 'Keys',
      key: 'keys',
      icon: <Icon fontSize="small">key</Icon>,
      viewType: 'keys',
      path: 'keys',
      component: <Keys />,
      functionality: RoleEnum.ADMIN,
      operation: 'read'
    },
    {
      type: 'collapse',
      name: 'Users',
      key: 'users',
      icon: <Icon fontSize="small">person</Icon>,
      viewType: 'users',
      path: 'users',
      component: <Users />,
      functionality: RoleEnum.ADMIN,
      operation: 'read'
    },
    {
      type: 'collapse',
      name: 'Accounts',
      key: 'accounts',
      icon: <Icon fontSize="small">lock</Icon>,
      viewType: 'accounts',
      path: 'accounts',
      component: <Accounts />,
      functionality: RoleEnum.ADMIN,
      operation: 'read'
    },
    {
      type: 'collapse',
      name: 'AiProviders',
      key: 'aiProviders',
      icon: <Icon fontSize="small">factory_icon</Icon>,
      viewType: 'aiProviders',
      path: 'aiProviders',
      component: <AiProviders />,
      functionality: RoleEnum.ADMIN,
      operation: 'read'
    },
    {
      type: 'collapse',
      name: 'AiModels',
      key: 'aiModels',
      icon: <Icon fontSize="small">smart_toy_icon</Icon>,
      viewType: 'aiModels',
      path: 'aiModels',
      component: <AiModels />,
      functionality: RoleEnum.ADMIN,
      operation: 'read'
    },
    {
      type: 'collapse',
      name: 'AdminAssistants',
      key: 'adminAssistants',
      icon: <Icon fontSize="small">assistant_rounded</Icon>,
      viewType: 'AdminAssistants',
      path: 'adminAssistants',
      component: <AdminAssistants />,
      functionality: RoleEnum.ADMIN,
      operation: 'read'
    },
    {
      type: 'collapse',
      name: 'Prompts',
      key: 'prompts',
      icon: <Icon fontSize="small">speaker_notes</Icon>,
      viewType: 'prompts',
      path: 'prompts',
      component: <Prompts />,
      functionality: RoleEnum.ADMIN,
      operation: 'read'
    },
    {
      type: 'collapse',
      name: 'Scripts',
      key: 'scripts',
      icon: <Icon fontSize="small">content_paste_icon</Icon>,
      viewType: 'scripts',
      path: 'scripts',
      component: <Scripts />,
      functionality: RoleEnum.ADMIN,
      operation: 'read'
    },
    {
      type: 'collapse',
      name: 'Anonymize',
      key: 'anonymize',
      icon: <Icon fontSize="small">gpp_bad</Icon>,
      viewType: 'anonymize',
      path: 'anonymize',
      component: <AnonymizeTools />,
      functionality: RoleEnum.ADMIN,
      operation: 'read'
    },
    {
      type: 'collapse',
      name: 'Usages',
      key: 'usages',
      icon: <Icon fontSize="small">bar_chart</Icon>,
      viewType: 'usages',
      path: 'usages',
      component: <Usages />,
      functionality: RoleEnum.ADMIN,
      operation: 'read'
    },
    {
      type: 'collapse',
      name: 'importExportConfiguration',
      key: 'importExportConfiguration',
      icon: <Icon fontSize="small">import_export_icon</Icon>,
      viewType: 'importExportConfiguration',
      path: 'importExportConfiguration',
      component: <ImportExportConfiguration />,
      functionality: RoleEnum.ADMIN,
      operation: 'read'
    }
  ];

  const knowledgeBaseRoutes = [
    {
      type: 'collapse',
      name: 'Documents',
      key: 'KBdocuments',
      icon: <Icon fontSize="small">folder_copy_icon</Icon>,
      viewType: 'KBdocuments',
      path: 'documents',
      component: <KnowledgeBaseDocuments />,
      functionality: RoleEnum.ADMIN,
      operation: 'read'
    },
    {
      type: 'collapse',
      name: 'Indexation',
      key: 'embbedding',
      icon: <Icon fontSize="small">format_list_bulleted_icon</Icon>,
      viewType: 'embbedding',
      path: 'embbedding',
      component: <Embedding />,
      functionality: RoleEnum.ADMIN,
      operation: 'read'
    },
    {
      type: 'collapse',
      name: 'Import',
      key: 'import',
      icon: <Icon fontSize="small">cloud_upload</Icon>,
      viewType: 'import',
      path: 'import',
      component: <KnowledgeBaseBatch />,
      functionality: RoleEnum.ADMIN,
      operation: 'read'
    }
  ];

  const filteredMainRoutes = mainRoutes.filter(
    (route) =>
      !route.functionality || currentUser.isAuthorized(route.functionality, route.operation)
  );
  const filteredAdminRoutes = adminRoutes.filter(
    (route) =>
      !route.functionality || currentUser.isAuthorized(route.functionality, route.operation)
  );
  const filteredKnowledgeBaseRoutes = knowledgeBaseRoutes.filter(
    (route) =>
      !route.functionality || currentUser.isAuthorized(route.functionality, route.operation)
  );

  return {
    allRoutes: [...filteredMainRoutes, ...filteredAdminRoutes, ...filteredKnowledgeBaseRoutes],
    mainRoutes: [...filteredMainRoutes],
    adminRoutes: [...filteredAdminRoutes],
    knowledgeBaseRoutes: [...filteredKnowledgeBaseRoutes]
  };
};

export default useRoutes;
